import { computed } from 'vue';
import { FeatureFlagName } from 'SharedDir/declarations/system/region-customization';
import { FeatureFlagsService } from 'SharedDir/service/region-feature-flags';

export function useFeatureFlags() {
  function isFeatureEnabled(featureName: FeatureFlagName): boolean {
    return FeatureFlagsService.isFeatureEnabled(featureName);
  }

  function getFeatureFlag(featureName: FeatureFlagName) {
    return computed(() => isFeatureEnabled(featureName));
  }

  return {
    isFeatureEnabled,
    getFeatureFlag,
  };
}
